/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {BarbarianFuryGameAssets} from "../BarbarianFuryGameAssets";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Align, Direction, GuiLayout} from "@nolimitcity/slot-launcher/bin/gui/utils/GuiLayout";

export class BarbarianFuryIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000,
            bulletColor:0xffffff
        },
        stampColor:0xFFFFFF,
    };


    stampConfig:StampConfig = {
        xWays:false,
        xNudge:true,
        volatility:Volatility.HIGH
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];
    bgBlack:PIXI.Sprite;

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add(BarbarianFuryGameAssets.INTRO_LOGO,BarbarianFuryGameAssets.INTRO_LOGO);
        imgLoader.add(BarbarianFuryGameAssets.INTRO_BORDER,BarbarianFuryGameAssets.INTRO_BORDER);
        imgLoader.add(BarbarianFuryGameAssets.GAME_INTRO_RESPIN,BarbarianFuryGameAssets.GAME_INTRO_RESPIN);
        imgLoader.add(BarbarianFuryGameAssets.GAME_INTRO_SCATTERS,BarbarianFuryGameAssets.GAME_INTRO_SCATTERS);
        imgLoader.add(BarbarianFuryGameAssets.GAME_INTRO_WILD,BarbarianFuryGameAssets.GAME_INTRO_WILD);
        imgLoader.add(BarbarianFuryGameAssets.MAIN_GAME_BACKGROUND,BarbarianFuryGameAssets.MAIN_GAME_BACKGROUND);
        imgLoader.add(BarbarianFuryGameAssets.MAIN_GAME_STONE_FOREGROUND,BarbarianFuryGameAssets.MAIN_GAME_STONE_FOREGROUND);
        imgLoader.add(BarbarianFuryGameAssets.WIN_AMOUNT_SHADOW,BarbarianFuryGameAssets.WIN_AMOUNT_SHADOW); //Not actually needed for into, but was included in that spitesheet so it needs to be loaded.

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();

        this.bgBlack = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.bgBlack.anchor.set(0.5, 0.5);
        this.bgBlack.tint = 0x020f12;
        this.bgBlack.alpha = 0.7;
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture(BarbarianFuryGameAssets.MAIN_GAME_BACKGROUND));
        bgSprite.anchor.set(0.5, 0.5);

        const stoneForeground = new PIXI.Sprite(ImgLoader.getImgTexture(BarbarianFuryGameAssets.MAIN_GAME_STONE_FOREGROUND));
        stoneForeground.anchor.set(0.5, 0.5);
        stoneForeground.position.set(0, 500);

        this.background.addChild(bgSprite);
        this.background.addChild(stoneForeground);
        this.background.addChild(this.bgBlack);


        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(BarbarianFuryGameAssets.INTRO_BORDER), 1680, 5);
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();

        const bottomSprite = new PIXI.TilingSprite(ImgLoader.getImgTexture(BarbarianFuryGameAssets.INTRO_BORDER), 1680, 5);
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);


        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture(BarbarianFuryGameAssets.INTRO_LOGO));
        logoSprite.anchor.set(0.5, 0.5);
        logoSprite.scale.set(0.6, 0.6);
        this.logo.addChild(logoSprite);

        const featureText1 = /*"HARLEQUIN xNUDGE WILDS\n\n" + */SlotGame.api.translations.translate("Harlequin xNudge Wilds will always nudge and increase the multiplier!");
        const featureText2 = /*"HARLEQUIN RESPIN\n\n" + */ SlotGame.api.translations.translate("The xNudge Wild will walk one step to the left on the reel and award a respin.");
        const featureText3 = /*"HARLEQUIN BONUS\n\n" + */ SlotGame.api.translations.translate("Collect 3 Bonus symbols award 8 Harlequin Bonus spins, where xNudge Wilds may be multiplied up to x7!");

        const features = new PIXI.Container();
        const scattersFeature = new PIXI.Sprite(GameResources.getTextures(BarbarianFuryGameAssets.GAME_INTRO_SCATTERS)[0]);
        const respinFeature = new PIXI.Sprite(GameResources.getTextures(BarbarianFuryGameAssets.GAME_INTRO_RESPIN)[0]);
        const wildFeature = new PIXI.Sprite(GameResources.getTextures(BarbarianFuryGameAssets.GAME_INTRO_WILD)[0]);

        features.addChild(scattersFeature, respinFeature,wildFeature);
        GuiLayout.align([scattersFeature, respinFeature,wildFeature], 20, Align.CENTER,Direction.HORIZONTAL);

        features.pivot.set(features.width * 0.5, features.height * 0.5);
        features.scale.set(0.9, 0.9);
        features.position.set(0,10);

        const page = new SlideShowPage();
        page.addChild(features);

        this.pages = [
            page
        ];

    }

    onResize(): void {
        const bounds = NolimitApplication.screenBounds;
        this.bgBlack.width = bounds.width;
        this.bgBlack.height = bounds.height;
    }
}